
import { RegExpUtility } from "../RegExpUtility";
import { Caret } from "./Caret";
import { SplitLineInfo } from "./LinesSplitter";

export enum LineType
{
  FIRST,
  CRLF,
  CR,
  LF
}

export class Line
{
  content:string;
  breakingType:LineType;  

  get text()
  {
    return this.breakingTypeToString() + this.content; 
  }

  breakingTypeToString()
  {
    if ( LineType.FIRST === this.breakingType )
    {
      return "";
    }
    else if ( LineType.CRLF === this.breakingType )
    {
      return "\r\n";
    }
    else if ( LineType.CR === this.breakingType )
    {
      return "\r";
    }
    else if ( LineType.LF === this.breakingType )
    {
      return "\n";
    }
  }

  cutout( start:number, end:number )
  {  
    let min = Math.min( start, end );
    let max = Math.max( start, end ); 

    let length = ( max - min + 1 );

    

    let before = this.content;
    let contentLength = this.content.length;
    this.content = RegExpUtility.cutoutRange( this.content, min, length );

    console.log( "cutout", { start, end, min, max, length, contentLength } );
    console.log( before );
    console.log( ">>" );
    console.log( this.content );    
  }

  getContentBefore( index:number, includeIndex:boolean = false )
  {
    return this.content.substring( 0, includeIndex ? index + 1 : index );
  }

  getContentAfter( index:number, includeIndex:boolean = true )
  {
    return this.content.substring( includeIndex ? index : ( index + 1 ), this.content.length );
  }
  
  setBreakType( breakSource:string )
  {
    if ( ! breakSource || breakSource.length === 0 )
    {
      this.breakingType = LineType.FIRST;
    }
    else if ( breakSource === "\r\n" )
    {
      this.breakingType = LineType.CRLF;
    }
    else if ( breakSource === "\r" )
    {
      this.breakingType = LineType.CR;
    }
    else if ( breakSource === "\n" )
    {
      this.breakingType = LineType.LF;
    }
  }

  static from( sl:SplitLineInfo )
  {
    let line = new Line();
    line.content = sl.content;
    line.setBreakType( sl.breakType );
    return line;
  }
}